import { Enums } from "../common/enums";

export class OpImportItemSummary {

    //Properties

    public key: any
    public importStatus: Enums.ImportStatus
    public description: string

    //Properties end

    constructor(opObj: any) {
        if (opObj) {
            this.key = opObj.Key
            this.importStatus = opObj.ImportStatus
            this.description = opObj.Description
        }
    }
}